import React from "react";

// The real store marks, replacing lucide's `Apple` (which is a piece of FRUIT
// with a leaf, not Apple Inc's logo) and a hand-drawn monochrome approximation
// of the Play triangle.
//
// A NOTE ON THE BADGE GUIDELINES, since this is the file where it matters.
// Apple and Google both publish finished "Download on the App Store" and "Get
// it on Google Play" lockups and would rather you used those verbatim than
// build your own. We build our own on purpose: the supplied artwork is a fixed
// raster block that ignores our type, our radius and our light/dark tone, and
// the editorial badge is a deliberate call recorded in AppDownload.tsx. Using
// the correct marks INSIDE that badge is strictly closer to compliant than the
// fruit was. If we ever want to be exactly by the book, the swap is to drop the
// official SVG lockups in whole and delete the custom badge; say the word.

/**
 * Apple's logo. Monochrome and driven by `currentColor`, so it inverts with the
 * badge tone rather than being pinned to one colour.
 */
export function AppleGlyph({ className = "w-5 h-5" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M17.564 12.727c-.03-3.02 2.463-4.468 2.575-4.539-1.402-2.05-3.585-2.331-4.362-2.363-1.857-.188-3.625 1.093-4.567 1.093-.941 0-2.394-1.066-3.933-1.037-2.023.03-3.888 1.176-4.928 2.988-2.1 3.64-.537 9.03 1.51 11.985 1 1.447 2.193 3.07 3.759 3.012 1.508-.06 2.077-.975 3.9-.975 1.822 0 2.334.975 3.928.945 1.622-.03 2.65-1.474 3.641-2.926 1.148-1.678 1.62-3.302 1.649-3.386-.036-.015-3.164-1.214-3.195-4.815-.026-3.012 2.46-4.455 2.573-4.526" />
      <path d="M14.6 4.06c.832-1.009 1.394-2.412 1.24-3.81-1.199.048-2.652.799-3.512 1.806-.77.893-1.446 2.32-1.265 3.69 1.339.104 2.705-.68 3.537-1.686" />
    </svg>
  );
}

/**
 * The Google Play triangle, in its four colours. Deliberately NOT currentColor:
 * Google's mark is defined by those colours, and a monochrome version is a
 * different logo. It reads correctly on both the dark and the light badge.
 */
export function GooglePlayGlyph({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {/* left edge, the fold of the triangle */}
      <path
        fill="#00D3FF"
        d="M3.27 1.94a1.5 1.5 0 0 0-.35.98v18.16c0 .38.13.72.35.98l9.4-10.06z"
      />
      {/* upper face */}
      <path
        fill="#00F076"
        d="M3.27 1.94a1.2 1.2 0 0 1 1.4-.12l11.2 6.34-3.2 3.74z"
      />
      {/* lower face */}
      <path
        fill="#FF3A44"
        d="M3.27 22.06a1.2 1.2 0 0 0 1.4.12l11.2-6.34-3.2-3.74z"
      />
      {/* the tip */}
      <path
        fill="#FFCE00"
        d="M15.87 8.16 12.67 12l3.2 3.84 4.06-2.3c.9-.51.9-1.57 0-2.08z"
      />
    </svg>
  );
}
